import {
  AvailabilityInterval,
  IntervalHeadcountCount,
  ReservableAvailabilityReason,
} from './types';

export function computeRemainingSpots(
  intervalCounts: IntervalHeadcountCount[],
  maxQuantityPerSlot: number
): AvailabilityInterval[] {
  return intervalCounts.map(i => {
    const remainingSpots = Math.max(0, maxQuantityPerSlot - i.count);

    return {
      startDate: i.interval.start.toJSDate(),
      endDate: i.interval.end.toJSDate(),
      eventType: i.eventType,
      remainingSpots,
      reason: remainingSpots === 0 ? ReservableAvailabilityReason.Full : null,
    };
  });
}
